module.exports = __webpack_public_path__ + "img/user1.f846d65b.png";